import { SNAP_ORIGIN } from '../env';

/**
 * The snap origin to use.
 * Will default to the local hosted snap if no value is provided in environment.
 */
export const defaultSnapOrigin = SNAP_ORIGIN ?? `local:http://localhost:8080`;

export const isLocalSnap = defaultSnapOrigin.startsWith(`local:`);
